module.exports = __webpack_public_path__ + "media/images/tailwind/close-icon-white-f8fc8a1028d6ec984018b4b459889f2f.png";